import { TextBlockSkeleton } from '@common/components/Skeletons/TextBlockSkeleton';
import { useSelectedCollectionMetadata } from '@features/Collection/hooks';
import { CreditRole } from '@features/Collection/metadataTypes';
import { DataList } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

const displayOrder: CreditRole[] = [
    'directors',
    'actors',
    // 'writers',
    // 'music',
] as const;

export const CreditsBlock = () => {
    const { t } = useTranslation('collectionDetails');
    const { data: metadata, isLoading } = useSelectedCollectionMetadata();
    const credits = metadata.credits;

    return (
        <TextBlockSkeleton loading={isLoading} size={5}>
            <DataList.Root>
                {displayOrder.map((role) => {
                    const count = credits[role].length;
                    const value = credits[role].join(', ');
                    return (
                        <DataList.Item key={role} align='center'>
                            <DataList.Label minWidth='88px'>
                                {t(`metadata.credits.${role.toLowerCase()}`, {
                                    count,
                                })}
                            </DataList.Label>
                            <DataList.Value>{value}</DataList.Value>
                        </DataList.Item>
                    );
                })}
            </DataList.Root>
        </TextBlockSkeleton>
    );
};
